export const getElementByIriFromArr = (iri,arr) =>{
    for (const element of arr) {
        if(element["@id"]===iri)return element
    }
}